<template>
  <div class="page" v-loading="listLoading">
    <!--    导出  Export    导入物流信息 importLogisticsInfo-->
    <!--    订单详情   orderDetail-->
    <el-form inline @submit.native.prevent label-width="130px">
<!--      <el-form-item label="供应商ID:">-->
<!--        <el-input v-model="searchData.SupId" placeholder="供应商ID" clearable></el-input>-->
<!--      </el-form-item>-->

      <el-form-item label="是否是商城管理员:">
        <el-select @change="getStatus3" v-model="value3" placeholder="请选择">
          <el-option
              v-for="item in options3"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
<!--        <el-input v-model="searchData.IsAdmin" placeholder="请输入商品名称" clearable></el-input>-->
      </el-form-item>

      <el-form-item label="订单号:">
        <el-input v-model="searchData.ChildOrderNo" placeholder="订单号" clearable></el-input>
      </el-form-item>

      <el-form-item label="订单状态">
<!--        <el-select @change="getStatus" v-model="value1" placeholder="请选择">-->
<!--          <el-option-->
<!--              v-for="item in options"-->
<!--              :key="item.value"-->
<!--              :label="item.label"-->
<!--              :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
        <el-input v-model="searchData.Status" placeholder="订单状态" clearable></el-input>
      </el-form-item>


      <el-form-item label="入账状态:">
<!--        <el-select @change="getStatus1" v-model="value2" placeholder="请选择">-->
<!--          <el-option-->
<!--              v-for="item in options1"-->
<!--              :key="item.value"-->
<!--              :label="item.label"-->
<!--              :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
        <el-input v-model="searchData.PushStatus" placeholder="入账状态" clearable></el-input>
        <!--        <el-input v-model="searchData.PushStatus" placeholder="收货人电话" clearable></el-input>-->
      </el-form-item>
      <el-form-item label="入账时间：">
        <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        @change="handlePicker"
                        style="width:100%">
        </el-date-picker>
      </el-form-item>
      <!--      <el-row>-->
      <!--        <el-col :span="6">-->
      <!--          <el-form-item label="外部订单号">-->
      <!--            <el-input v-model="searchData.OutOrderNo" placeholder="请输入"></el-input>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--        <el-col :span="6">-->
      <!--          <el-form-item label="供应商" prop="SupplierId">-->
      <!--            <el-select v-model="searchData.SupplierId" filterable remote placeholder="请选择 / 可搜索"-->
      <!--                       :remote-method="querySupplier" style="width:100%">-->
      <!--              <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">-->
      <!--              </el-option>-->
      <!--            </el-select>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--        <el-col :span="12">-->
      <!--          <el-form-item label="下单时间：">-->
      <!--            <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"-->
      <!--                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"-->
      <!--                            style="width:100%">-->
      <!--            </el-date-picker>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <el-form-item>
        <div style="display: flex;">
          <el-button type="primary" @click="searchFun">查询</el-button>
          <el-button @click="resetFun">重置</el-button>
          <!--          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
        </div>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
              @selection-change="selectCurrentRow" style="width: 100%" border>
<!--      <el-table-column fixed="left" prop="mainOrderId" label="主订单ID" align="center"></el-table-column>-->
<!--      <el-table-column prop="childOrderId" label="子订单ID" align="center"></el-table-column>-->
      <el-table-column fixed prop="erpOrderNo" label="erp子订单号" align="center"></el-table-column>
      <el-table-column prop="childOrderNo" label="子订单号" align="center"></el-table-column>
      <el-table-column prop="spuId" label="spuId" align="center"></el-table-column>
      <el-table-column prop="modelCode" label="商品型号" align="center"></el-table-column>
      <el-table-column prop="skuId" label="SKUID" align="center"></el-table-column>
      <el-table-column prop="skuCode" label="Sku编码" align="center"></el-table-column>
      <el-table-column prop="skuName" label="SKU名称" width=120 align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="skuSpecs" label="商品规格" align="center"></el-table-column>
      <el-table-column label="Sku图片" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.skuPicUrl" width="120" />
        </template>
      </el-table-column>
      <el-table-column prop="skuPrice" label="SKU价格" align="center"></el-table-column>
      <el-table-column prop="amount" label="订单实付金额" align="center"></el-table-column>
      <el-table-column prop="pushAmount" label="订单入账金额" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="pushTime" label="收到入账的金额" align="center"></el-table-column>
      <el-table-column prop="status" label="订单状态" align="center">
<!--        <template>-->
<!--          <template slot-scope="scoped">-->
<!--            <el-tag v-if="scoped.row.status == 10">待支付</el-tag>-->
<!--            <el-tag v-if="scoped.row.status == 20" type="success">备货中(待发货)</el-tag>-->
<!--            <el-tag v-if="scoped.row.status == 30" type="info">待收货(已发货)</el-tag>-->
<!--            <el-tag v-if="scoped.row.status == 40" type="warning">已收货</el-tag>-->
<!--            <el-tag v-if="scoped.row.status == 50" type="danger">已完成</el-tag>-->
<!--            <el-tag v-if="scoped.row.status == 60" type="danger">已取消</el-tag>-->
<!--            <el-tag v-if="scoped.row.status == 70" type="danger">已关闭</el-tag>-->
<!--          </template>-->
<!--        </template>-->
      </el-table-column>
      <el-table-column prop="pushStatus" label="入账状态" align="center">
<!--        <template slot-scope="scoped">-->
<!--          <el-tag v-if="scoped.row.pushStatus == 10">待支付</el-tag>-->
<!--          <el-tag v-if="scoped.row.pushStatus == 20" type="success">备货中(待发货)</el-tag>-->
<!--          <el-tag v-if="scoped.row.pushStatus == 30" type="info">待收货(已发货)</el-tag>-->
<!--          <el-tag v-if="scoped.row.pushStatus == 40" type="warning">已收货</el-tag>-->
<!--          <el-tag v-if="scoped.row.pushStatus == 50" type="danger">已完成</el-tag>-->
<!--          <el-tag v-if="scoped.row.pushStatus == 60" type="danger">已取消</el-tag>-->
<!--          <el-tag v-if="scoped.row.pushStatus == 70" type="danger">已关闭</el-tag>-->
<!--        </template>-->
      </el-table-column>
      <!--      <el-table-column width="200" label="操作" fixed="right" align="center">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
      <!--                     @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
      <!--          </el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>
    <el-pagination class="pagination" layout="total, prev, pager, next" @size-change="handleSizeChange"
                   :current-page="searchData.PageIndex" :pageSize="searchData.PageSize"
                   @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
               :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
                   :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit(2)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload,
  SupplierGetAll, OrderCMBPayList
} from "../../../api/api";
import {getButtonList} from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: {Toolbar},
  data() {
    return {
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [{'id': 1}],
      productNavTypeTreeList: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        // SupId: null,
        IsAdmin: null,
        Status: null,
        PushStatus: null,
        ChildOrderNo: '',
        // productSkuName: null,
        // receivingName: null,
        // receivingMobile: null,
        // Status: 9,
        // StartTime: null,
        // EndTime: null,
        // OutOrderNo: "",
        // SupplierId: "",
      },
      options: [{
        value: '10',
        label: '待支付'
      }, {
        value: '20',
        label: '待发货'
      }, {
        value: '30',
        label: '已发货'
      }, {
        value: '40',
        label: '已收货'
      }, {
        value: '50',
        label: '已完成'
      }, {
        value: '60',
        label: '已取消'
      }, {
        value: '70',
        label: '已关闭'
      }],
      options1: [{
        value: '10',
        label: '待支付'
      }, {
        value: '20',
        label: '待发货'
      }, {
        value: '30',
        label: '已发货'
      }, {
        value: '40',
        label: '已收货'
      }, {
        value: '50',
        label: '已完成'
      }, {
        value: '60',
        label: '已取消'
      }, {
        value: '70',
        label: '已关闭'
      }],
      options3: [{
        value: 'true',
        label: '是'
      }, {
        value: 'false',
        label: '否'
      }],
      value: '',
      value1: '',
      value2: '',
      value3: '',
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      supplier: [],
    };
  },
  created() {
    // this.getProductNavTypeTree();
    // this.getBrandList();
    this.getTableList();
    // this.querySupplier()
  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    getStatus(val) {
      console.log('=====', val);
      this.searchData.Status = val;
    },
    getStatus1(val) {
      console.log('=====', val);
      this.searchData.PushStatus = val;
    },
    getStatus3(val) {
      console.log('=====', val);
      this.searchData.IsAdmin = val;
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=UTF-8'})
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
          "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    orderDetail(button, index, row) {
      // this.$router.push(
      //     `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    async getTableList(searchData) {
      // if (!this.searchData.SupId) return this.$message.error('请选择供应商ID')
      // console.log('OrderCMBPayList();',OrderCMBPayList());
      this.listLoading = true;
      // let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      // this.searchData.SkipCount = SkipCount;
      // this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await OrderCMBPayList(this.searchData);
      if (res.data.success) {
        console.log('res-----', res)
        if (res.data.result.data && res.data.result.data.dataCount){
          this.total = res.data.result.data.dataCount
        }else{
          this.total = 0
        }
        if (res.data.result.data && res.data.result.data.data){
          this.tableList = res.data.result.data.data;
        }else{
          this.tableList = [];
        }

      } else {
        this.$message.error(res.data.msg)
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 500);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ids: list}).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ids: list}).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({parentId: 0}).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.searchData.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(e) {
      console.log('llllll', e)
      if (e == null) {
        this.valueTime = []
        this.searchData.StartTime = null;
        this.searchData.EndTime = null;
      } else {
        this.searchData.StartTime = e[0];
        this.searchData.EndTime = e[1];
      }
    },
    resetFun() {
      this.searchData.PageIndex = 1;
      this.searchData.PageSize = 10;
      this.searchData.IsAdmin = null;
      this.searchData.Status = null;
      this.searchData.PushStatus = null;
      this.searchData.ChildOrderNo = '';

      this.value1 = '';
      this.value2 = '';
      this.value3 = '';
      this.valueTime = [];
      this.getTableList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      console.log('bal', val)
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      // this.listLoading = false;
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
    querySupplier(value) {
      SupplierGetAll({
        SkipCount: 0,
        MaxResultCount: 100,
        supplierName: value
      }).then(res => {
        if (res.data.success) {
          this.supplier = res.data.result.items
        }
      })
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
